import { render, staticRenderFns } from "./CostBasisRollForwardReportOld.vue?vue&type=template&id=1af90904&"
import script from "./CostBasisRollForwardReportOld.vue?vue&type=script&lang=ts&"
export * from "./CostBasisRollForwardReportOld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports